/**
 * Klaviyo Back In Stock — storefront i18n (vanilla JS).
 * MutationObserver + debounce; stable selectors only (no Klaviyo go* classes).
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 120;
  var OBS_ROOT = document.body || document.documentElement;

  /** @type {Record<string, Record<string, string>>} */
  var TRANSLATIONS = {
    es: {
      bisButton: 'Avísame cuando esté disponible',
      modalTitle: 'AVÍSAME CUANDO VUELVA A ESTAR DISPONIBLE',
      modalBody: 'Te enviaremos un email cuando este producto vuelva a estar disponible.',
      emailLabel: 'Email',
      emailPlaceholder: 'Introduce tu email',
      promoCheckbox: 'También acepto recibir emails promocionales.',
      submitButton: 'Avísame',
      closeAria: 'Cerrar diálogo',
      successTitle: '¡LISTO!',
      successBody: 'Te avisaremos cuando vuelva a estar disponible.'
    },
    en: {
      bisButton: 'Notify me when available',
      modalTitle: 'NOTIFY ME WHEN THIS IS BACK IN STOCK',
      modalBody: 'We will email you when this product is available again.',
      emailLabel: 'Email',
      emailPlaceholder: 'Enter your email',
      promoCheckbox: 'I also agree to receive promotional emails.',
      submitButton: 'Notify me',
      closeAria: 'Close dialog',
      successTitle: "YOU'RE IN!",
      successBody: "We'll let you know when it's back."
    },
    de: {
      bisButton: 'Benachrichtige mich, wenn verfügbar',
      modalTitle: 'BENACHRICHTIGE MICH, WENN WIEDER VERFÜGBAR',
      modalBody: 'Wir senden dir eine E-Mail, wenn dieses Produkt wieder verfügbar ist.',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'E-Mail-Adresse eingeben',
      promoCheckbox: 'Ich stimme zu, Werbe-E-Mails zu erhalten.',
      submitButton: 'Benachrichtigen',
      closeAria: 'Dialog schließen',
      successTitle: 'GESCHAFFT!',
      successBody: 'Wir melden uns, sobald es wieder da ist.'
    },
    fr: {
      bisButton: 'Prévenez-moi quand ce sera disponible',
      modalTitle: 'PRÉVENEZ-MOI QUAND CE SERA DE NOUVEAU DISPONIBLE',
      modalBody: 'Nous vous enverrons un e-mail lorsque ce produit sera de nouveau disponible.',
      emailLabel: 'E-mail',
      emailPlaceholder: 'Saisissez votre e-mail',
      promoCheckbox: "J'accepte également de recevoir des e-mails promotionnels.",
      submitButton: 'Me prévenir',
      closeAria: 'Fermer la boîte de dialogue',
      successTitle: "C'EST NOTÉ !",
      successBody: 'Nous vous préviendrons dès son retour.'
    },
    it: {
      bisButton: 'Avvisami quando disponibile',
      modalTitle: 'AVVISAMI QUANDO TORNA DISPONIBILE',
      modalBody: 'Ti invieremo un’email quando questo prodotto sarà di nuovo disponibile.',
      emailLabel: 'Email',
      emailPlaceholder: 'Inserisci la tua email',
      promoCheckbox: 'Accetto anche di ricevere email promozionali.',
      submitButton: 'Avvisami',
      closeAria: 'Chiudi finestra',
      successTitle: 'FATTO!',
      successBody: 'Ti avviseremo appena sarà di nuovo disponibile.'
    },
    pt: {
      bisButton: 'Avisar-me quando estiver disponível',
      modalTitle: 'AVISE-ME QUANDO ESTIVER DE NOVO DISPONÍVEL',
      modalBody: 'Enviar-lhe-emos um email quando este produto voltar a estar disponível.',
      emailLabel: 'Email',
      emailPlaceholder: 'Introduza o seu email',
      promoCheckbox: 'Também aceito receber emails promocionais.',
      submitButton: 'Avisar-me',
      closeAria: 'Fechar diálogo',
      successTitle: 'ESTÁ FEITO!',
      successBody: 'Avisá-lo-emos assim que voltar a estar disponível.'
    }
  };

  function debounce(fn, ms) {
    var t = null;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }

  function normalizeLocale() {
    var raw =
      (document.documentElement && document.documentElement.getAttribute('lang')) ||
      (typeof Shopify !== 'undefined' && Shopify.locale ? String(Shopify.locale) : '') ||
      '';
    raw = raw.trim().toLowerCase();
    if (!raw) return 'es';
    if (raw.indexOf('pt') === 0) return 'pt';
    var base = raw.split('-')[0];
    if (TRANSLATIONS[base]) return base;
    return 'es';
  }

  function stringsFor(loc) {
    return TRANSLATIONS[loc] || TRANSLATIONS.en || TRANSLATIONS.es;
  }

  function stampKey(loc, part) {
    return loc + ':' + part;
  }

  function comparableValue(el, part) {
    if (!el) return '';
    if (part === 'emailPh') return (el.getAttribute('placeholder') || '').trim();
    if (part === 'closeAria' || part === 'promoAria') return (el.getAttribute('aria-label') || '').trim();
    if (el.tagName === 'INPUT' && el.type === 'email') return (el.getAttribute('placeholder') || '').trim();
    if (el.tagName === 'H1' && (part === 'modalTitle' || part === 'successTitle')) {
      var st = el.querySelector('strong');
      return (st ? st.textContent : el.textContent || '').trim();
    }
    return (el.textContent || el.value || '').trim();
  }

  function alreadyApplied(el, loc, part, nextText) {
    if (!el || !el.getAttribute) return false;
    if (el.getAttribute('data-kl-bis-i18n') !== stampKey(loc, part)) return false;
    return comparableValue(el, part) === (nextText || '').trim();
  }

  function applyText(el, text, loc, part) {
    if (!el || text == null) return;
    if (alreadyApplied(el, loc, part, text)) return;
    el.textContent = text;
    el.setAttribute('data-kl-bis-i18n', stampKey(loc, part));
  }

  function applyHeadingTitle(h1, text, loc, part) {
    if (!h1) return;
    if (alreadyApplied(h1, loc, part, text)) return;
    var strong = h1.querySelector('strong');
    if (strong) strong.textContent = text;
    else h1.textContent = text;
    h1.setAttribute('data-kl-bis-i18n', stampKey(loc, part));
  }

  function applyPlaceholder(input, text, loc, part) {
    if (!input || text == null) return;
    if (alreadyApplied(input, loc, part, text)) return;
    input.setAttribute('placeholder', text);
    input.setAttribute('data-kl-bis-i18n', stampKey(loc, part));
  }

  function applyAria(el, text, loc, part) {
    if (!el || text == null) return;
    if (alreadyApplied(el, loc, part, text)) return;
    el.setAttribute('aria-label', text);
    el.setAttribute('data-kl-bis-i18n', stampKey(loc, part));
  }

  function translateBisTriggerButtons(loc, t) {
    var root = document.getElementById('klaviyo-bis-button-container');
    if (!root) return;
    var buttons = root.querySelectorAll('button[type="button"][data-a11y-identifier^="bis-button"]');
    if (!buttons.length) buttons = root.querySelectorAll('button[type="button"]');
    buttons.forEach(function (btn) {
      applyText(btn, t.bisButton, loc, 'bisButton');
    });
  }

  function translateCloseButton(popup, loc, t) {
    var closeBtn = popup.querySelector('button.klaviyo-close-form[aria-label]');
    if (!closeBtn) closeBtn = popup.querySelector('button[aria-label="Close dialog"]');
    if (!closeBtn) return;
    if (alreadyApplied(closeBtn, loc, 'closeAria', t.closeAria)) return;
    closeBtn.setAttribute('aria-label', t.closeAria);
    closeBtn.setAttribute('data-kl-bis-i18n', stampKey(loc, 'closeAria'));
    var titleEl = closeBtn.querySelector('svg title');
    if (titleEl) titleEl.textContent = t.closeAria;
  }

  function isMainTitleH1(text) {
    var u = text.toUpperCase();
    return u.indexOf('AVÍSAME CUANDO') !== -1 || u.indexOf('NOTIFY ME WHEN') !== -1 || u.indexOf('BENACHRICHTIGE') !== -1 || u.indexOf('PRÉVENEZ-MOI') !== -1 || u.indexOf('AVVISAMI QUANDO') !== -1 || u.indexOf('AVISE-ME') !== -1;
  }

  function isLikelyModalBodyStrong(text) {
    var lower = text.toLowerCase();
    return (
      lower.indexOf('enviaremos') !== -1 ||
      (lower.indexOf('enviar') !== -1 && lower.indexOf('email') !== -1) ||
      lower.indexOf('we will email') !== -1 ||
      lower.indexOf('vous enverrons') !== -1 ||
      lower.indexOf('wir senden') !== -1 ||
      lower.indexOf('ti invieremo') !== -1 ||
      lower.indexOf('enviar-lhe') !== -1 ||
      lower.indexOf('nous vous enverrons') !== -1
    );
  }

  function translateSuccessBlocks(form, loc, t) {
    form.querySelectorAll('.klaviyo-form-richtext h1').forEach(function (h1) {
      var txt = (h1.textContent || '').trim();
      if (!txt) return;
      if (isMainTitleH1(txt)) return;
      var upper = txt.toUpperCase();
      if (/GRACIAS|THANK|MERCI|DANKE|GRAZIE|OBRI|LISTO|GESCHAFFT|FATTO|NOTÉ|YOU'RE/.test(upper)) {
        applyHeadingTitle(h1, t.successTitle, loc, 'successTitle');
      }
    });
    form.querySelectorAll('.klaviyo-form-richtext strong').forEach(function (s) {
      var text = (s.textContent || '').trim();
      if (!text || isLikelyModalBodyStrong(text)) return;
      var lower = text.toLowerCase();
      if (!/(gracias|thanks|thank you|merci|danke|obrigad|grazie|geschafft)/i.test(lower)) return;
      applyText(s, t.successBody, loc, 'successBody');
    });
  }

  function translateModalForm(form, loc, t) {
    var rows = form.querySelectorAll('[data-testid="form-row"]');
    var titleDone = false;
    var bodyDone = false;
    rows.forEach(function (row) {
      var rt = row.querySelector('.klaviyo-form-richtext');
      if (!rt) return;
      var h1 = rt.querySelector('h1');
      if (h1 && !titleDone) {
        applyHeadingTitle(h1, t.modalTitle, loc, 'modalTitle');
        titleDone = true;
        return;
      }
      if (!h1 && !bodyDone) {
        var strong = rt.querySelector('strong');
        if (strong) {
          applyText(strong, t.modalBody, loc, 'modalBody');
          bodyDone = true;
        }
      }
    });

    var emailWrap = form.querySelector('.klaviyo-emailinput');
    if (emailWrap) {
      var input = emailWrap.querySelector('input[type="email"][name="email"]');
      var label = emailWrap.querySelector('label.klaviyo-sr-only[for]');
      if (label) applyText(label, t.emailLabel, loc, 'emailLabel');
      if (input) applyPlaceholder(input, t.emailPlaceholder, loc, 'emailPh');
    }

    var promoInput = form.querySelector('input[type="checkbox"][name^="opt_in_promotional_email"]');
    if (promoInput) {
      applyAria(promoInput, t.promoCheckbox, loc, 'promoAria');
      if (promoInput.id) {
        var fid =
          typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
            ? CSS.escape(promoInput.id)
            : String(promoInput.id).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        var lab = form.querySelector('label[for="' + fid + '"]');
        if (lab) {
          var textDiv = null;
          var ch = lab.children;
          for (var i = 0; i < ch.length; i++) {
            var node = ch[i];
            if (node.tagName === 'DIV' && node.textContent.trim().length > 2) textDiv = node;
          }
          if (textDiv) applyText(textDiv, t.promoCheckbox, loc, 'promoLabel');
        }
      }
    }

    var submitBtn = form.querySelector('button[type="button"].klaviyo-form-button');
    if (submitBtn) applyText(submitBtn, t.submitButton, loc, 'submit');

    translateSuccessBlocks(form, loc, t);
  }

  function translatePopup(popup, loc, t) {
    if (!popup || popup.getAttribute('data-testid') !== 'POPUP') return;
    var form = popup.querySelector('form[aria-live="polite"][data-testid^="klaviyo-form"]');
    if (!form) form = popup.querySelector('form.klaviyo-form[data-testid^="klaviyo-form"]');
    if (!form) form = popup.querySelector('form.klaviyo-form');
    if (!form) return;
    translateCloseButton(popup, loc, t);
    translateModalForm(form, loc, t);
  }

  function translateAll() {
    var loc = normalizeLocale();
    var t = stringsFor(loc);
    translateBisTriggerButtons(loc, t);
    document.querySelectorAll('[data-testid="POPUP"]').forEach(function (popup) {
      translatePopup(popup, loc, t);
    });
  }

  var scheduled = debounce(translateAll, DEBOUNCE_MS);

  function init() {
    translateAll();
    if (!OBS_ROOT || typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function () {
      scheduled();
    });
    mo.observe(OBS_ROOT, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', scheduled);
    document.addEventListener('shopify:section:reorder', scheduled);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.KlaviyoBisI18n = { refresh: translateAll, normalizeLocale: normalizeLocale };
})();
